import { z } from 'zod';

export const RestaurantConfigSchema = z.object({
  id: z.number(),
  name: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
  subtitle: z.string().nullable(),
  imageGallery: z.array(
    z.object({
      externalKey: z.string(),
      url: z.string(),
    })
  ),
  openingTime: z.string(),
  closingTime: z.string(),
  menu: z.array(
    z.object({
      id: z.number(),
      file: z.object({
        externalKey: z.string(),
        url: z.string(),
      }),
      name: z.string(),
    })
  ),
  property: z.object({ id: z.number() }),
});

export const MappedRestaurantsSchema = z.array(
  z.object({
    closedDates: z.object({
      closedDays: z.array(z.any()),
      closedPeriods: z.array(z.any()),
      id: z.number().optional(),
      leaveTime: z.string().optional(),
    }),
    config: RestaurantConfigSchema,
    label: z.string(),
    restaurantName: z.string(),
    value: z.string(),
  })
);

export type MappedRestaurantsType = z.infer<typeof MappedRestaurantsSchema>;
export type RestaurantConfigType = z.infer<typeof RestaurantConfigSchema>;
